<template>
  <div class="security">
    <mynav></mynav>
    <div class="videoBg">
      <div style="max-width: 1200px; margin: 0 auto">
        <video
          src="../assets/puls.mp4"
          width="100%"
          autoplay="autoplay"
          loop="loop"
          muted
          playsinline="true"
        >
          您的浏览器不支持 video 标签。
        </video>
      </div>
    </div>
    <div class="yingyong">
      <div class="item-title">公安政务平台应用</div>
      <div class="yingyong-content">
        <p style="margin-bottom: 30px">
          “成长树”警员Ai管理系统是一套居于大数据深度分析的可视化用户画像管理方案。目前已在上海公安系统率先部署使用，成为推动“智慧政工”建设的载体，为50000余名民警提供警员大数据可视化分析管理。系统部署在上海公安的多环境内网及公安政务云，具备最高级别的规范性及安全性。
        </p>
        <p>
          从市局、分局、派出所、科室到个人，实现全维度可数据视化分析。利用大数据，定期自动生成「警员能力」月报、年报，对数据进行智能研判，分析优劣势，促进警员成长，优化警所可视化管理，为制定相关政策提供决策依据。
        </p>
      </div>
    </div>
    <div class="phone">
      <img src="../assets/phone.png" alt="" :width="phoneWidth" />
    </div>
    <div class="general">
      <div class="item-title">头部客户成功案例</div>
      <div class="case-content general-content">
        <div
          class="case-content-item"
          v-for="(item, index) in caseData"
          :key="index"
        >
          <img :src="item.img1" alt="" />
          <div class="case-content-item-bottom">
            <img :src="item.img2" alt="" />
            <div>
              <h4>{{ item.name }}</h4>
              <p>{{ item.text }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- <myfooter :type="1"></myfooter> -->
  </div>
</template>
    <script>
// import myfooter from "../components/myfooter.vue";
import mynav from "../components/mynav.vue";
export default {
  data() {
    return {
      caseData: [
        {
          name: "上海市公安局",
          text: "警员绩效，大数据应用系统",
          img1: require("../assets/cover4.jpg"),
          img2: require("../assets/coverLogo4.jpg"),
        },
        {
          name: "司法鉴定科学研究院",
          text: "为科研、教培、技术执法赋能",
          img1: require("../assets/cover5.jpg"),
          img2: require("../assets/coverLogo5.jpg"),
        },
        {
          name: "数字哨兵",
          text: "上海大数据中心合作伙伴",
          img1: require("../assets/cover6.jpg"),
          img2: require("../assets/coverLogo6.jpg"),
        },
      ],
      phoneWidth: "",
    };
  },
  components: {
    // myfooter,
    mynav,
  },
  created() {},
  mounted() {
    this.getWidth();
    window.onresize = () => {
      this.getWidth();
    };

    this.$nextTick(() => {
      document.querySelector("video").play();
      document.addEventListener(
        "WeixinJSBridgeReady",
        function () {
          document.querySelector("video").play();
        },
        false
      );
    });
  },
  methods: {
    getWidth() {
      let height1 = document.body.clientWidth;
      let height2 = document.querySelector("video").clientWidth;
      if (height1 > 1440) {
        this.phoneWidth = height2 + "px";
      } else {
        this.phoneWidth = (height1 - height2) / 2 + height2 + "px";
      }
    },
  },
};
</script>
<style lang="less" scoped>
.security {
  .top {
    display: flex;
    justify-content: center;
  }
  .yingyong {
    width: 100%;
    padding-top: 40px;
    .yingyong-content {
      color: #495267b3;
      font-size: 18px;
      line-height: 38px;
      max-width: 1000px;
      margin: 0 auto;
    }
  }

  .phone {
    width: 100%;
    padding-top: 70px;
    display: flex;
    justify-content: flex-end;
  }
  .general {
    clear: both;
    .case-content {
      padding-bottom: 50px;
      display: flex;
      justify-content: center;
      flex-wrap: wrap;
      .case-content-item {
        width: 300px;
        margin: 10px 8.6px;
        box-shadow: 0px 4px 14px rgba(75, 103, 136, 0.1);
        img {
          width: 100%;
        }
        .case-content-item-bottom {
          display: flex;
          align-items: center;
          color: #21293e;
          padding: 10px 5px;
          box-sizing: border-box;
          img {
            width: 65px;
          }
          p {
            font-size: 10px;
          }
        }
      }
    }
  }
}

@media screen and (min-width: 1440px) {
  .security {
    .phone {
      justify-content: center;
    }
  }
}

@media screen and (max-width: 1200px) {
  .security {
    .yingyong {
      .yingyong-content {
        width: 97%;
        margin: 0 auto;
      }
    }
  }
}

@media screen and (max-width: 992px) {
  .security {
    .top {
      display: flex;
      justify-content: center;
    }
    .yingyong {
      width: 100%;
      padding-top: 20px;
      .yingyong-content {
        font-size: 16px;
        line-height: 30px;
        width: 90%;
        margin: 0 auto;
      }
    }

    .operating {
      clear: both;
      background-color: #f5f7f9;
      .operating-content {
        p {
          text-align: center;
          color: rgba(73, 82, 103, 0.7);
          font-size: 16px;
          font-weight: 400;
          line-height: 32px;
        }
        img {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
  }
}
@media screen and (max-width: 768px) {
  .security {
    .top {
      display: flex;
      justify-content: center;
    }
    .yingyong {
      width: 100%;
      padding-top: 20px;
      .yingyong-content {
        margin-bottom: 30px;
        font-size: 16px;
      }
    }

    .operating {
      clear: both;
      background-color: #f5f7f9;
      .operating-content {
        width: 90%;
        p {
          font-size: 14px;
          line-height: 32px;
        }
        img {
          width: 100%;
          margin-top: 20px;
        }
      }
    }
    .general {
      .case-content {
        justify-content: space-between;
        .case-content-item {
          width: 48%;
          margin: 0 0 10px 0;
          .case-content-item-bottom {
            padding: 8px 3px;
            img {
              width: 40px;
            }
            h4 {
              font-size: 14px;
            }
            p {
              font-size: 10px;
            }
          }
        }
      }
    }
  }
}
</style>